<template>
  <section class="settings-group">
    <header class="group-header">
      <h2 class="group-title">{{ group.title }}</h2>
      <p v-if="group.description" class="group-description">
        {{ group.description }}
      </p>
    </header>
    
    <div class="group-content">
      <SettingsItem
        v-for="item in group.items"
        :key="item.id"
        :setting="item"
        :scope="scope"
        @update="onSettingUpdate"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import SettingsItem from './SettingsItem.vue';
import type { SettingsGroup } from './SettingsPanel.vue';

export interface SettingsGroupProps {
  group: SettingsGroup;
  scope: 'user' | 'workspace';
}

defineProps<SettingsGroupProps>();

const emit = defineEmits<{
  'update': [key: string, value: any];
}>();

const onSettingUpdate = (key: string, value: any) => {
  emit('update', key, value);
};
</script>

<style scoped lang="scss">
@use '@/styles/mixins';

.settings-group {
  border: 1px solid var(--vscode-border);
  border-radius: var(--border-radius);
  background-color: var(--vscode-backgroundSecondary);
}

.group-header {
  padding: var(--spacing-lg) var(--spacing-xl);
  border-bottom: 1px solid var(--vscode-border);
}

.group-title {
  margin: 0 0 var(--spacing-sm) 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--vscode-foreground);
}

.group-description {
  margin: 0;
  font-size: 14px;
  color: var(--vscode-foreground);
  opacity: 0.8;
  line-height: 1.4;
}

.group-content {
  padding: var(--spacing-md) var(--spacing-xl);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}
</style>
